import { h, type FunctionalComponent } from '@stencil/core';
import type { IDashboardTile } from '../../types/subcomponents-types.type';
import { DashboardItemHeader } from '../dashboard-item-header/dashboard-item-header';

export const DashboardGenericTile: FunctionalComponent<IDashboardTile> = (
  props,
  children
) => {
    const {
      customValueClass,
      labelProvider,
      title,
      targetTab,
      tabCount,
      mobileView,
      subTitle,
      privateCard,
      itemCount,
      term
    } = props;
    const showSubTitle = (subTitle === null || subTitle === undefined) ? true : subTitle;
    const privateCardHeder = privateCard == null ? false : privateCard;

    return (
      <div
        class={`tail__container ${customValueClass ? customValueClass : ''}`}
        data-card-area={'background'}
      >
        <div class="tail__header">
          <DashboardItemHeader
            title={title}
            labelProvider={(e, f) => props.labelProvider(e, f)}
            targetTab={targetTab}
            tabCount={tabCount}
            subTitle={showSubTitle}
            privateCard={privateCardHeder}
            mobileView={mobileView}
            itemCount={itemCount}
            term={term}
          />
        </div>
        {children}
        <div class="tail__footer">
          <uiaas-dashboard-tab-button
            labelProvider={(e, f) => labelProvider(e, f)}
            targetTab={targetTab}
            tabCount={tabCount}
            tabName={mobileView ? targetTab : ''}
            mobileView={props.mobileView}
          />
        </div>
      </div>
    );
};
